import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "chevron"]
  static values  = { open: { type: Boolean, default: false } }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    this.contentTarget.hidden = !this.openValue
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", this.openValue)
    }
  }
}
